export const MAP_DOMAIN = 'https://maps.googleapis.com';
/**
 * This api key is only used for the static map which has specified HTTP referrers restrictions
 * @type {string}
 */
export const STATIC_MAP_API_KEY = 'AIzaSyBO0SmbCYRBChVLiJu000up_hfOSuzir_w';
/**
 * This api key is only used for the map which does not have specified HTTP referrers restrictions
 * When you add HTTP referrers to a google api key you cannot use that key for local development that is using 0.0.0.0
 * If you want to use google maps during local development you have to exclude the key param from the url.
 * With the current set up if you exclude apiConfigOptions.apiKey from the Map/MapList component coming from react-map-components or react-things-of-interest-components it will load for local development
 * @type {string}
 */
export const MAP_API_KEY = 'AIzaSyAuTVpqdhOjXImD9o_pBPWRm2WL0hMf1Qk';
export const MAP_API_SECRET = '5oXK_oVndVUYu8C4wa9UfTicYQI';
